

/*
 * Borcelle Boutique - Multiple Combo Cart
 * Adds selected products without removing existing items.
 * Supports multiple combo packs and extra single products.
 */

(() => {
  if (window.BorcelleMultiComboReady) return;
  window.BorcelleMultiComboReady = true;

  const root = window.Shopify?.routes?.root || '/';

  async function cartRequest(path, body) {
    const response = await fetch(root + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Unable to update cart.'
      );
    }

    return result;
  }

  function refresh(combo) {
    const required = Number(combo.dataset.quantity);

    const selected = combo.querySelectorAll(
      '.bb-check:checked'
    ).length;

    const button = combo.querySelector('.bb-add');
    const counter = combo.querySelector('.bb-count');

    if (counter) {
      counter.textContent =
        `${selected} / ${required} selected`;
    }

    if (button && button.dataset.busy !== 'true') {
      button.disabled = selected !== required;

      button.textContent = selected === required
        ? 'Add Selected Combo to Cart'
        : `Select ${Math.max(0, required - selected)} More Products`;
    }
  }

  function initializeCombos() {
    document.querySelectorAll('.bb-combo').forEach(combo => {
      refresh(combo);
    });
  }

  // Select or deselect combo products.
  document.addEventListener('change', event => {
    if (!event.target.matches('.bb-check')) return;

    const combo = event.target.closest('.bb-combo');
    if (!combo) return;

    const required = Number(combo.dataset.quantity);
    const selected = combo.querySelectorAll(
      '.bb-check:checked'
    );

    const message = combo.querySelector('.bb-message');

    if (selected.length > required) {
      event.target.checked = false;

      if (message) {
        message.textContent =
          `You can select only ${required} products per combo.`;
      }
    } else if (message) {
      message.textContent = '';
    }

    refresh(combo);
  });

  // Show more products.
  document.addEventListener('click', async event => {
    const more = event.target.closest('.bb-more');

    if (more) {
      event.preventDefault();

      const combo = more.closest('.bb-combo');
      const grid = combo?.querySelector('.bb-products');

      if (!grid) return;

      const expanded =
        grid.classList.toggle('bb-expanded');

      grid.querySelectorAll('.bb-extra').forEach(item => {
        item.style.display = expanded ? 'block' : 'none';
      });

      more.textContent = expanded
        ? 'Show Less Products'
        : 'Show More Products';

      return;
    }

    // Add selected combo without deleting existing cart items.
    const button = event.target.closest('.bb-add');

    if (!button || button.disabled) return;

    event.preventDefault();

    const combo = button.closest('.bb-combo');
    if (!combo) return;

    if (button.dataset.busy === 'true') return;

    const required = Number(combo.dataset.quantity);

    const selections = [
      ...combo.querySelectorAll('.bb-check:checked')
    ];

    if (selections.length !== required) {
      refresh(combo);
      return;
    }

    const message = combo.querySelector('.bb-message');

    const variants = selections.map(check => {
      const product = check.closest('.bb-product');

      return Number(
        product?.querySelector('.bb-variant')?.value
      );
    });

    if (variants.some(id => !Number.isSafeInteger(id) || id <= 0)) {
      if (message) {
        message.textContent =
          'Please select a valid product option.';
      }
      return;
    }

    // Every selection adds one unit.
    // Existing quantities are preserved.
    // Repeated variants increase their quantities.
    const quantities = new Map();

    variants.forEach(id => {
      quantities.set(
        id,
        (quantities.get(id) || 0) + 1
      );
    });

    const items = [...quantities.entries()].map(
      ([id, quantity]) => ({
        id,
        quantity
      })
    );

    button.dataset.busy = 'true';
    button.disabled = true;
    button.textContent = 'Adding Combo...';

    if (message) {
      message.textContent = '';
    }

    try {
      // Add products only - no cart/update.js removal.
      await cartRequest('cart/add.js', { items });

      // Reopen the cart after page reload.
      sessionStorage.setItem(
        'borcelleReopenCart',
        '1'
      );

      window.location.reload();

    } catch (error) {
      if (message) {
        message.textContent =
          error.message ||
          'Unable to add combo. Please try again.';
      }

      button.dataset.busy = 'false';
      refresh(combo);
    }
  });

  // Reopen Dwell Cart Drawer after adding a combo.
  function reopenCart() {
    if (
      sessionStorage.getItem('borcelleReopenCart') !== '1'
    ) return;

    const cartDrawer = document.getElementById(
      'cart-drawer'
    );

    const dialog = cartDrawer?.querySelector('dialog');

    if (!dialog) return;

    try {
      if (!dialog.open) {
        dialog.showModal();
      }

      sessionStorage.removeItem(
        'borcelleReopenCart'
      );

    } catch (error) {
      console.warn(
        'Borcelle: Could not reopen cart drawer.',
        error
      );
    }
  }

  function initialize() {
    initializeCombos();
    reopenCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }

})();

